import { makeAutoObservable, toJS } from "mobx";
import UserStore from "./user_store";

class ResumeStore {


    resumeBuilder = {
        personalDetails: {
            jobTitle: "",
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            country: "",
            city: "",
            address: "",
            postalCode: "",
            drivingLicense: "",
            nationality: "",
            dateOfBirth: "",
            placeOfBirth: "",
        },
        profile: null,
        primaryColor: "#1e3a8a",
        secondaryColor: "black",

        profileSummary: "",


        employementHistory: [
            // {
            //     jobTitle: "",
            //     company: "",
            //     city: "",
            //     startDate: "",
            //     endDate: "",
            //     description: "",
            // }
        ],

        education: [
            // {

            //     school: "",
            //     degree: "",
            //     startDate: "",
            //     endDate: "",
            //     city: "",
            //     description: "",
            // }
        ],

        websites: [
            // {
            //     label: "",
            //     link: "",
            // }
        ],
        skills: [],

        languages: [
            // {   
            //     language:"",
            //     level:"",
            // }
        ],

        customSection: [
            // {
            //     language:"",
            //     institution:"",
            //     startDate:"",
            //     endDate:"",
            // }
        ],
        courses: [
            // {
            //     course:"",
            //     institution:"",
            //     startDate:"",
            //     endDate:"",
            // }
        ],
        extraCurricularActivities: [
            // {
            //     functionTitle:"",
            //     employer:"",
            //     startDate:"",
            //     endDate:"",
            //     city:"",
            //     description:"",
            // }
        ],

        internships: [
            // {
            //     jobTitle:"",
            //     employer:"",
            //     startDate:"",
            //     endDate:"",
            //     city:"",
            //     description:"",
            // }
        ],

        hobbies: [],

        references: [
            // {
            //     referentsName: "",
            //     company: "",
            //     phone: "",
            //     email: "",
            // }
        ]
    }
    autofill = () => {
        const user = JSON.parse(localStorage.getItem("user"))
        // Split the name by spaces
        const nameParts = user.name.split(" ");
        // Assign first and last name
        const firstName = nameParts[0];
        const lastName = nameParts.slice(1).join(" ");

        const date = new Date(user?.dob);

        // Extract day, month, and year
        const day = date.getDate();
        const month = date.getMonth() + 1; // Months are zero-based, so add 1
        const year = date.getFullYear();
        console.log(`Current Year: ${year}`); 
        

        // Format as `DD-MM-YYYY`
        const formattedDate = `${day}-${month}-${year}`;

        console.log(user, "gggg")
        this.resumeBuilder = {
            personalDetails: {
                jobTitle: user?.designation,
                firstName: firstName,
                lastName: lastName,
                email: user?.mail,
                phone: user?.mobile,
                country: "",
                city: "",
                address: "",
                postalCode: "",
                drivingLicense: "",
                nationality: "",
                dateOfBirth: formattedDate,
                placeOfBirth: "",
            },
            profile: user?.pic,
            primaryColor: "#1e3a8a",
            secondaryColor: "black",
            profileSummary: user.bio.split(" ").length > 50 
            ? user.bio.split(" ").slice(0, 50).join(" ") + "..." 
            : user.bio,
            employementHistory: user?.previousCompanies.length > 0
            ? user?.previousCompanies.map(company => ({
                jobTitle: company.designation,
                company: company.company,
                startDate: company.joiningDate,
                endDate: company.completionDate,
                description: "Description of responsibilities and achievements", // Customize as needed
            }))
            : [], // Leave it empty if no previous companies,
            education: [
                {
                    school: user?.college,
                    degree: user?.qualification,
                    startDate: "",
                    endDate: ``,
                    city: "",
                    description: "",
                },
                // {
                //     school: "MIT",
                //     degree: "Master of Science in Artificial Intelligence",
                //     startDate: "2018-02-01",
                //     endDate: "2020-12-31",
                //     city: "Cambridge",
                //     description: "Research focus on machine learning and natural language processing...",
                // },
                // {
                //     school: "Stanford University",
                //     degree: "Ph.D. in Computer Engineering",
                //     startDate: "2021-01-01",
                //     endDate: "Present",
                //     city: "Stanford",
                //     description: "Doctoral research in distributed systems and cloud computing...",
                // },
                // Add more education entries if needed
            ],
            websites: [
                // { label: "Portfolio", link: "https://www.johndoe.com" },
                // { label: "LinkedIn", link: "https://www.linkedin.com/in/johndoe" },
                // Add more website entries if needed
            ],
            skills: user.skills,
            languages: [
                // { language: "English", level: "Native" },
                // { language: "Spanish", level: "Intermediate" },
                // Add more language entries if needed
            ],
            customSection: [
                // {
                //     customField: "Field1",
                //     institution: "Institution1",
                //     startDate: "2015-01-01",
                //     endDate: "2017-01-01",
                // },
                // {
                //     customField: "Field2",
                //     institution: "Institution2",
                //     startDate: "2018-01-01",
                //     endDate: "2020-01-01",
                // },
                // Add more customSection entries if needed
            ],
            courses: [
                // {
                //     course: "Advanced Web Development",
                //     institution: "Coding University",
                //     startDate: "2019-01-01",
                //     endDate: "2019-06-01",
                // },
                // {
                //     course: "Data Science Specialization",
                //     institution: "Online Learning Platform",
                //     startDate: "2020-01-01",
                //     endDate: "2020-06-01",
                // },
                // Add more courses entries if needed
            ],
            extraCurricularActivities: [
                // {
                //     functionTitle: "Volunteer Coordinator",
                //     employer: "Local Community Center",
                //     startDate: "2016-01-01",
                //     endDate: "2018-01-01",
                //     city: "New York",
                //     description: "Coordinated volunteer activities and events...",
                // },
                // {
                //     functionTitle: "Event Organizer",
                //     employer: "Tech Meetup Group",
                //     startDate: "2019-01-01",
                //     endDate: "Present",
                //     city: "New York",
                //     description: "Organizing monthly tech meetups and workshops...",
                // },
                // Add more extraCurricularActivities entries if needed
            ],
            internships: [
                // {
                //     jobTitle: "Software Development Intern",
                //     employer: "TechStartup",
                //     startDate: "2017-01-01",
                //     endDate: "2017-06-01",
                //     city: "San Francisco",
                //     description: "Worked on various projects, gaining hands-on experience...",
                // },
                // {
                //     jobTitle: "Research Intern",
                //     employer: "AI Research Lab",
                //     startDate: "2020-01-01",
                //     endDate: "2020-06-01",
                //     city: "Cambridge",
                //     description: "Contributed to cutting-edge research in artificial intelligence...",
                // },
                // Add more internships entries if needed
            ],
            hobbies: [],
            references: [
                // {
                //     referentsName: "Jane Smith",
                //     company: "ABC Corporation",
                //     phone: "+1 987-654-3210",
                //     email: "jane.smith@example.com",
                // },
                // {
                //     referentsName: "Michael Johnson",
                //     company: "XYZ Tech Solutions",
                //     phone: "+1 555-123-4567",
                //     email: "michael.johnson@example.com",
                // },
                // Add more references entries if needed
            ],
        };
    };

    resumeShow = false;

    setResumeShow = (value) => {
        this.resumeShow = value;
    }


    setProfile = (value) => {
        this.resumeBuilder.profile = value;
    }

    setPrimaryColor = (value) => {
        this.resumeBuilder.primaryColor = value;
    }

    setSecondaryColor = (value) => {
        this.resumeBuilder.secondaryColor = value;
    }

    updatePersonalDetails = (key, value) => {
        this.resumeBuilder.personalDetails[key] = value;
    }

    updateProfileSummary = (value) => {
        this.resumeBuilder.profileSummary = value;
    }

    updateEmployementHistory = (key, value, index) => {
        console.log(key, value, index);
        if (this.resumeBuilder.employementHistory[index] === undefined) {
            this.resumeBuilder.employementHistory[index] = {
                jobTitle: "",
                company: "",
                city: "",
                startDate: "",
                endDate: "",
                description: "",
            };
        }
        this.resumeBuilder.employementHistory[index][key] = value;
    }

    removeEmployementHistory = (index) => {
        this.resumeBuilder.employementHistory.splice(index, 1);
    }

    updateEducation = (key, value, index) => {
        console.log(key, value, index);
        if (this.resumeBuilder.education[index] === undefined) {
            this.resumeBuilder.education[index] = {
                school: "",
                degree: "",
                startDate: "",
                endDate: "",
                city: "",
                description: "",
            };
        }
        this.resumeBuilder.education[index][key] = value;
    }

    removeEducation = (index) => {
        this.resumeBuilder.education.splice(index, 1);
    }

    updateWebsites = (key, value, index) => {
        console.log(key, value, index);
        if (this.resumeBuilder.websites[index] === undefined) {
            this.resumeBuilder.websites[index] = {
                label: "",
                link: "",
            };
        }
        this.resumeBuilder.websites[index][key] = value;
    }

    removeWebsites = (index) => {
        this.resumeBuilder.websites.splice(index, 1);
    }

    updateLanguages = (key, value, index) => {
        console.log(key, value, index);
        if (this.resumeBuilder.languages[index] === undefined) {
            this.resumeBuilder.languages[index] = {
                language: "",
                level: "",
            };
        }
        this.resumeBuilder.languages[index][key] = value;
    }

    removeLanguages = (index) => {
        this.resumeBuilder.languages.splice(index, 1);
    }

    updateCourses = (key, value, index) => {
        console.log(key, value, index);
        if (this.resumeBuilder.courses[index] === undefined) {
            this.resumeBuilder.courses[index] = {
                course: "",
                institution: "",
                startDate: "",
                endDate: "",
            };
        }
        this.resumeBuilder.courses[index][key] = value;
    }

    removeCourses = (index) => {
        this.resumeBuilder.courses.splice(index, 1);
    }

    updateExtraCurricularActivities = (key, value, index) => {
        console.log(key, value, index);
        if (this.resumeBuilder.extraCurricularActivities[index] === undefined) {
            this.resumeBuilder.extraCurricularActivities[index] = {
                functionTitle: "",
                employer: "",
                startDate: "",
                endDate: "",
                city: "",
                description: "",
            };
        }
        this.resumeBuilder.extraCurricularActivities[index][key] = value;
    }

    removeExtraCurricularActivities = (index) => {
        this.resumeBuilder.extraCurricularActivities.splice(index, 1);
    }

    updateInternships = (key, value, index) => {
        console.log(key, value, index);
        if (this.resumeBuilder.internships[index] === undefined) {
            this.resumeBuilder.internships[index] = {
                jobTitle: "",
                employer: "",
                startDate: "",
                endDate: "",
                city: "",
                description: "",
            };
        }
        this.resumeBuilder.internships[index][key] = value;
    }

    removeInternships = (index) => {
        this.resumeBuilder.internships.splice(index, 1);
    }

    updateReferences = (key, value, index) => {
        console.log(key, value, index);
        if (this.resumeBuilder.references[index] === undefined) {
            this.resumeBuilder.references[index] = {
                referentsName: "",
                company: "",
                phone: "",
                email: "",
            };
        }
        this.resumeBuilder.references[index][key] = value;
    }

    removeReferences = (index) => {
        this.resumeBuilder.references.splice(index, 1);
    }

    updateResumeBuilder = (key, value) => {
        this.resumeBuilder[key] = value;
    }

    setHobbies = (value) => {
        this.resumeBuilder.hobbies = [...this.resumeBuilder.hobbies, value];
    }

    removeHobbies = (index) => {
        this.resumeBuilder.hobbies.splice(index, 1);
    }

    setSkills = (value) => {
        this.resumeBuilder.skills = [...this.resumeBuilder.skills, value];
    }

    removeSkills = (index) => {
        this.resumeBuilder.skills.splice(index, 1);
    }

    setExtraCurricularActivities = (value) => {
        this.resumeBuilder.extraCurricularActivities = [...this.resumeBuilder.extraCurricularActivities, value];
    }

    setReferences = (value) => {
        this.resumeBuilder.references = [...this.resumeBuilder.references, value];
    }

    setInternships = (value) => {
        this.resumeBuilder.internships = [...this.resumeBuilder.internships, value];
    }

    setCourses = (value) => {
        this.resumeBuilder.courses = [...this.resumeBuilder.courses, value];
    }

    setLanguages = (value) => {
        this.resumeBuilder.languages = [...this.resumeBuilder.languages, value];
    }

    setWebsites = (value) => {
        this.resumeBuilder.websites = [...this.resumeBuilder.websites, value];
    }

    setEducation = (value) => {
        this.resumeBuilder.education = [...this.resumeBuilder.education, value];
    }

    setEmployementHistory = (value) => {
        this.resumeBuilder.employementHistory = [...this.resumeBuilder.employementHistory, value];
    }

    constructor() {
        makeAutoObservable(this);
    }
}

export default ResumeStore;
